import { postMultiplePart } from "helpers/api_helper";

export const apiUploadImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return postMultiplePart(`/master/image/upload/`, formData);
};
